/**
 * AppQia - Variante de la app para Quantia (tenant por defecto).
 *
 * Diseño Quantia (lavender white, lima/morado, Fira Sans). Se renderiza
 * cuando TENANT === 'qia' (es decir, cuando la URL NO empieza por /met).
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';

import theme from './theme/theme';
import { AuthProvider } from './context/AuthContext';
import { TENANT_BASENAME } from './config/tenant';

import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';

import Login from './pages/Login';
import Home from './pages/Home';
import Analizar from './pages/Analizar';
import Generar from './pages/Generar';

function AppQia() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router basename={TENANT_BASENAME}>
        <AuthProvider>
          <Box
            sx={{
              minHeight: '100vh',
              backgroundColor: theme.palette.background.default,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Header />
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Home />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/analizar"
                  element={
                    <ProtectedRoute>
                      <Analizar />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/generar"
                  element={
                    <ProtectedRoute>
                      <Generar />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </Box>
          </Box>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default AppQia;
